import React from 'react';
import { connect } from 'react-redux';
import { deleteUser } from './user.store';
import { TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import { Modal } from 'react-bootstrap';
import {
  Button, Checkbox,
} from '../../form/FormControls.jsx';
import { MainComponentBox, UrlWrappedLink, LinkLikeButton,
  TableOptions, navTo } from '../../../util/util.jsx';
import { getUsersListWrapper } from './UserWrapper.js';
import { ReactBootstrapTableRemotePagination } from
  '@/component/form/ReactBootstrapTableRemotePagination.jsx';
import { ROLES } from './RoleElement';
import trash from '../../../../style/trash.png';
import { getTextFilter } from '@/component/form/ReactBootstrapTableTextFilter';
import pencil from '../../../../style/pencil.png';

const mapStateToProps = (state) => (
  { users: state.getIn(['data', 'users']) }
);

const mapDispatchToProps = (dispatch) => (
  {
    deleteUser: (id) => {
      deleteUser(dispatch, id);
    },
  }
);

class List extends React.Component {
  constructor(props) {
    super(props);
    this.renderModificationButtons = this.renderModificationButtons.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.yesButton = this.yesButton.bind(this);
    this.state = { showModal: false, id: undefined };
  }
  componentWillMount() {
    getUsersListWrapper();
  }
  componentWillReceiveProps() {
    getUsersListWrapper();
  }

  openModal(id) {
    this.setState({ showModal: true, id });
  }
  closeModal() {
    this.setState({ showModal: false, id: undefined });
  }
  yesButton() {
    this.props.deleteUser(this.state.id);
    this.setState({ showModal: false, id: undefined });
  }

  transformRoles = roles => roles.map(role => {
    const t = ROLES.find(i => i.value === role, this, []);
    if (t && t.label) {
      return t.label;
    }
    return null;
  });

  renderModificationButtons(cell) {
    return (<div className={'reference-mod-column'}>
      <LinkLikeButton id={`delete_${cell}`} onClick={() => this.openModal(cell)}>
        <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
      </LinkLikeButton>
      <UrlWrappedLink url={`/management/users/${cell}`} id={`edit_${cell}`}>
        <img
          src={pencil} alt={'edit'} title={'edit'} className={'payments-table-small-icon'}
        />
      </UrlWrappedLink>
    </div>);
  }

  renderEnableStatus = cell => (
    <div className="users__management-status">
      <Checkbox type="checkbox" disabled defaultChecked={!!cell} />
    </div>
  );

  renderUserRoles = cell => (
    <div className="users__management-roles">
      {cell.join(', ')}
    </div>
  );

  render() {
    return this.props.users ?
      <div className="dict">
        <MainComponentBox wide>
          <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal} >
            <Modal.Body>
            Are you sure you want to delete this user?
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={this.yesButton}>Yes</Button>
              <Button onClick={this.closeModal}>No</Button>
            </Modal.Footer>
          </Modal>
          <div id="users" className={'users-table references-list'}>
            <ReactBootstrapTableRemotePagination
              data={this.props.users.map(x => x
                .set('rolesAliases', this.transformRoles(x.get('roles', '')))
                .toJS())
                .toArray()}
              striped hover condensed bordered={false}
              options={TableOptions}
            >
              <TableHeaderColumn
                dataField="firstName"
                dataSort
                className={'references-name-header product-name-column-header'}
                columnClassName={'references-name-row product-name-column'}
                filter={{ type: 'CustomFilter',
                  getElement: getTextFilter,
                  customFilterParameters: { columnName: 'First name' },
                }}
              >
            First name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="lastName"
                dataSort
                columnClassName={'user-list-border-left'}
                className={'product-name-column-header references-name-header user-list-header'}
                filter={{ type: 'CustomFilter',
                  getElement: getTextFilter,
                  customFilterParameters: { columnName: 'Last name' },
                }}
              >
            Last name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="username"
                dataSort
                columnClassName={'user-list-border-left'}
                className={'product-name-column-header references-name-header user-list-header'}
                filter={{ type: 'CustomFilter',
                  getElement: getTextFilter,
                  customFilterParameters: { columnName: 'User name' },
                }}
              >
            User name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="rolesAliases"
                dataSort
                columnClassName={'user-list-border-left'}
                className={'product-name-column-header references-name-header user-list-header'}
                filter={{ type: 'CustomFilter',
                  getElement: getTextFilter,
                  customFilterParameters: { columnName: 'Roles' },
                }}
                dataFormat={this.renderUserRoles}
                width="630"
              >
            Roles
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName={'payments-pre-last-columns user-list-border-left'}
                className={'payments-pre-last-columns-header references-name-header ' +
                'product-name-column-header user-list-header'}
                dataField="enabled" dataSort dataFormat={this.renderEnableStatus}
                width="108"
              >
            Enabled
              </TableHeaderColumn>
              <TableHeaderColumn
                width="112"
                className={'payments-last-columns-header user-edit-column-header'}
                columnClassName={'payments-last-columns'}
                dataFormat={this.renderModificationButtons}
                searchable={false} dataField="id" isKey
              >
                <div>
                  <Button
                    id="addProduct"
                    bsStyle="primary"
                    onClick={() => navTo('/management/users/new')}
                  >
                    Add
                  </Button>
                </div>
              </TableHeaderColumn>
            </ReactBootstrapTableRemotePagination>
          </div>
        </MainComponentBox>
      </div>
      : <div></div>;
  }
}
List.propTypes = {
  users: React.PropTypes.object,
  deleteUser: React.PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(List);
